<template>
    <div class="wrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Contact Us</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="bd">
            <img src="../assets/imgs/uploads/mobile/Group 638.png" style="width: 100vw;" alt="">
            <div class="cts">
                <p style="text-align: center;">Contact us</p>
                <div style="font-size: 4.267vw;text-align: center;">
                    <p>Email: lotus@gigwi.com.hk</p>
                    <p>whatsApp: +8618795968284</p>
                </div>
            </div>
        </div>
        <div style="text-align: center;color: #282828;margin-bottom: 6.933vw;">
            <p class="issue">Do you have any question?</p>
            <p>Please fill out the form, </p>
            <p>we will contact you as soon as possible.</p>
            <p>Or you can find an answer in FAQ .</p>
        </div>
        <div class="send">
            <p style="font-weight: bold;font-size: 5.6vw;text-align: center;margin-bottom: 6.667vw;">Send a Message </p>
            <div>
                <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="auto">
                    <el-form-item prop="YouName" :rules="[
                        { required: true, message: '请输入', trigger: 'blur' },]">
                        <el-input v-model="dynamicValidateForm.YouName" placeholder="Name"></el-input>
                    </el-form-item>
                    <el-form-item prop="YouEmail" :rules="[
                        { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                    ]">
                        <el-input v-model="dynamicValidateForm.YouEmail" placeholder="E-mail"></el-input>
                    </el-form-item>
                    <el-input type="textarea" :rows="11" v-model="feedback"
                        placeholder="Type your message here..."></el-input>
                    <div class="btn1" style="text-align: center;">
                        <el-button @click="submitFeedback('dynamicValidateForm')">SUBMIT</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            userInfo: null,
            enquiry: '',
            feedback: '',
            YouName: '',
            YouEmail: '',
            dynamicValidateForm: {
                YouName: '',
                YouEmail: '',
            }
        }
    },
    mounted() {
        // 获取 localStorage 中的用户信息
        const storedUserInfo = localStorage.getItem('user');
        // 判断是否存在用户信息
        if (storedUserInfo) {
            this.userInfo = JSON.parse(storedUserInfo);
        }
    },
    methods: {
        successed() {
            if (this.feedback) {
                this.$message({
                    message: 'Message sent successfully!',
                    showClose: true,
                    type: 'success',
                    center: true
                });
                this.feedback = ''
            }
        },
        submitFeedback(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 构建包含用户名和反馈信息的对象
                    const data = {
                        memberId: this.userInfo ? this.userInfo.id : '',
                        feedback: this.feedback,
                        memberName: this.dynamicValidateForm.YouName,
                        email: this.dynamicValidateForm.YouEmail
                    };
                    if (this.feedback == "") {
                        this.$message({
                            message: this.$t('contactus.content'),
                            type: "warning",
                        });
                        return;
                    }
                    else {
                        // 使用axios发送POST请求
                        axios.post('/api/mall/customer/feedback', data)
                        this.successed()
                    }
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style scoped>
.wrapper {
    font-size: 16px;
    border-top: 1px solid #c7c7c7;
    margin-top: -1px;
}

.bd {
    position: relative;
}

.cts {
    font-size: 24px;
    font-weight: bold;
    color: #FFF;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.issue {
    margin: 26px 0 17px;
    font-size: 21px;
    font-weight: bold;
}

.send {
    background-color: #F8F8F8;
    padding: 24px 29px 41px;
}

::v-deep .btn1 .el-button {
    margin-top: 22px;
    width: 155px;
    height: 42px;
    font-size: 16px;
    color: #FFF;
    background-color: #000;
    border-radius: 35px;
    border: none;
}
</style>